import app from 'flarum/common/app';
import { BooleanGambit } from 'flarum/common/query/IGambit';
export default class QuestionGambit extends BooleanGambit {
  key() {
    return app.translator.trans('fof-best-answer.lib.gambits.qna.key', {}, true);
  }
  filterKey() {
    return 'qna';
  }
}
flarum.reg.add('fof-best-answer', 'common/gambits/QuestionGambit', QuestionGambit);